import { api } from '../utils/apiClient';

export type ServiceAccount = {
  id: string;
  organization_id: string;
  project_id: string | null;
  name: string;
  description?: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  last_used_at?: string | null;
};

export type ApiKeyRecord = {
  id: string;
  key_prefix: string;
  name?: string | null;
  scopes: string[];
  is_active: boolean;
  created_at: string;
  last_used_at?: string | null;
  revoked_at?: string | null;
};

export type ApiKeyCreateResponse = {
  api_key: string;
  key_prefix: string;
  service_account_id: string;
  warning: string;
};

export const CLI_FULL_PROJECT_WORKFLOW_SCOPES = [
  'library:read',
  'library:write',
  'observability:read',
  'observability:write',
  'build:read',
  'build:write',
  'selection:read',
  'selection:run',
  'results:read',
  'results:write',
  'history:read',
  'history:write',
];

export const DEFAULT_API_KEY_SCOPES = [...CLI_FULL_PROJECT_WORKFLOW_SCOPES];

export async function listServiceAccounts(projectId: string) {
  return api.get<ServiceAccount[]>(`/service-accounts?project_id=${projectId}`);
}

export async function createServiceAccount(payload: {
  project_id: string;
  name: string;
  description?: string;
}) {
  return api.post<ServiceAccount>('/service-accounts', payload);
}

export async function updateServiceAccount(
  id: string,
  payload: { name?: string; description?: string; is_active?: boolean }
) {
  return api.patch<ServiceAccount>(`/service-accounts/${id}`, payload);
}

export async function deleteServiceAccount(id: string) {
  return api.delete<ServiceAccount>(`/service-accounts/${id}`);
}

export async function listApiKeys(serviceAccountId: string) {
  return api.get<ApiKeyRecord[]>(`/service-accounts/${serviceAccountId}/api-keys`);
}

export async function createApiKey(
  serviceAccountId: string,
  payload: { name?: string; scopes: string[] }
) {
  return api.post<ApiKeyCreateResponse>(
    `/service-accounts/${serviceAccountId}/api-keys`,
    payload
  );
}

export async function revokeApiKey(id: string) {
  return api.delete<ApiKeyRecord>(`/service-accounts/api-keys/${id}`);
}
